import { z } from 'zod';
import { GeoPrecision, ImageRights, IssueSeverity, LinkType } from './enums.js';
/** Data locale (fuso Europe/Rome), senza orario: YYYY-MM-DD. */
export const LocalDate = z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/, 'data attesa nel formato YYYY-MM-DD')
    .meta({ id: 'LocalDate' });
/** Orario locale HH:mm (24h). */
export const LocalTime = z
    .string()
    .regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'orario atteso nel formato HH:mm')
    .meta({ id: 'LocalTime' });
/** Identificatore ULID (26 caratteri Crockford base32). */
export const Ulid = z
    .string()
    .regex(/^[0-9A-HJKMNP-TV-Z]{26}$/, 'ULID non valido')
    .meta({ id: 'Ulid' });
export const Slug = z
    .string()
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'slug in kebab-case minuscolo')
    .max(160)
    .meta({ id: 'Slug' });
/** Timestamp ISO 8601 in UTC (solo per metadati tecnici, mai per le date degli eventi). */
export const Timestamp = z.iso.datetime({ offset: true }).meta({ id: 'Timestamp' });
export const EventDate = z
    .object({
    date: LocalDate,
    start: LocalTime.optional(),
    end: LocalTime.optional(),
})
    .meta({ id: 'EventDate' });
export const LatLng = z
    .object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
})
    .meta({ id: 'LatLng' });
export const Geo = z
    .object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    precision: GeoPrecision,
})
    .meta({ id: 'Geo' });
export const Venue = z
    .object({
    name: z.string().max(200).optional(),
    address: z.string().max(300).optional(),
})
    .meta({ id: 'Venue' });
export const Link = z
    .object({
    type: LinkType,
    url: z.url(),
    label: z.string().max(120).optional(),
})
    .meta({ id: 'Link' });
export const Image = z
    .object({
    /** Chiave base in S3 /media (le varianti hanno suffisso -400.webp, -800.webp...). */
    key: z.string(),
    credit: z.string().max(200).optional(),
    rights: ImageRights,
    alt: z.string().max(300).optional(),
    /** dimensioni dell'originale (dopo la rotazione EXIF): il sito capisce se è una locandina */
    width: z.int().positive().optional(),
    height: z.int().positive().optional(),
})
    .meta({ id: 'Image' });
export const Seo = z
    .object({
    title: z.string().max(70),
    description: z.string().max(170),
})
    .meta({ id: 'Seo' });
export const Issue = z
    .object({
    code: z.string(),
    severity: IssueSeverity,
    message: z.string(),
    field: z.string().optional(),
})
    .meta({ id: 'Issue' });
//# sourceMappingURL=common.js.map